import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  ref: "dialog",
  class: "member-list"
};
var _hoisted_2 = {
  key: 0,
  class: "member-list-title"
};
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = {
  class: "member-list-box"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "member-list-box-body-name"
};
import TUIChatEngine, { TUIStore, StoreName, TUIGroupService, TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { TUIGlobal } from '@tencentcloud/universal-api';
import { ref, watch } from '../../../../adapter-vue';
import { isPC, isH5 } from '../../../../utils/env';
import BottomPopup from '../../../common/BottomPopup/index.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['onAtListOpen', 'insertAt'],
  setup(__props, _ref) {
    var {
      expose: __expose,
      emit: __emit
    } = _ref;
    var emits = __emit;
    var MessageInputAt = ref();
    var memberListItems = ref();
    var showAtList = ref(false);
    var memberList = ref();
    var allMemberList = ref();
    var showMemberList = ref();
    var isGroup = ref(false);
    var position = ref({
      left: 0,
      top: 0
    });
    var selectedIndex = ref(0);
    var _currentConversationID = ref('');
    var all = {
      userID: TUIChatEngine.TYPES.MSG_AT_ALL,
      nick: '所有人',
      isAll: true,
      avatar: 'https://web.sdk.qcloud.com/im/assets/images/at.svg'
    };
    TUIStore.watch(StoreName.CONV, {
      currentConversationID: id => {
        if (id !== _currentConversationID.value) {
          var _currentConversationI;
          _currentConversationID.value = id;
          memberList.value = [];
          allMemberList.value = [];
          showMemberList.value = [];
          isGroup.value = false;
          TUIStore.update(StoreName.CUSTOM, 'memberList', memberList.value);
          if (_currentConversationID !== null && _currentConversationID !== void 0 && (_currentConversationI = _currentConversationID.value) !== null && _currentConversationI !== void 0 && _currentConversationI.startsWith('GROUP')) {
            var _currentConversationI2;
            isGroup.value = true;
            var groupID = _currentConversationID === null || _currentConversationID === void 0 || (_currentConversationI2 = _currentConversationID.value) === null || _currentConversationI2 === void 0 ? void 0 : _currentConversationI2.substring(5);
            TUIGroupService.switchGroup(groupID);
          } else {
            TUIGroupService.switchGroup('');
          }
        }
      }
    });
    TUIStore.watch(StoreName.GRP, {
      currentGroupMemberList: list => {
        memberList.value = list;
        allMemberList.value = [all, ...memberList.value];
        showMemberList.value = allMemberList.value;
        TUIStore.update(StoreName.CUSTOM, 'memberList', memberList.value);
      }
    });
    var toggleAtList = show => {
      if (!isGroup.value) {
        return;
      }
      showAtList.value = show;
      if (showAtList.value) {
        emits('onAtListOpen');
      }
    };
    var handleAtListPosition = positionData => {
      position.value = positionData;
    };
    var setCurrentSelectIndex = index => {
      var _memberListItems$valu;
      selectedIndex.value = index;
      (_memberListItems$valu = memberListItems.value) === null || _memberListItems$valu === void 0 || (_memberListItems$valu = _memberListItems$valu[selectedIndex.value]) === null || _memberListItems$valu === void 0 || _memberListItems$valu.scrollIntoView(false);
    };
    var setShowMemberList = list => {
      showMemberList.value = list;
    };
    TUIGlobal.toggleAtList = toggleAtList;
    TUIGlobal.handleAtListPosition = handleAtListPosition;
    TUIGlobal.setCurrentSelectIndex = setCurrentSelectIndex;
    TUIGlobal.setShowMemberList = setShowMemberList;
    __expose({
      toggleAtList
    });
    watch(() => [position.value, MessageInputAt === null || MessageInputAt === void 0 ? void 0 : MessageInputAt.value], () => {
      var _MessageInputAt$value;
      if (isH5 || !(MessageInputAt !== null && MessageInputAt !== void 0 && MessageInputAt.value) || !(MessageInputAt !== null && MessageInputAt !== void 0 && (_MessageInputAt$value = MessageInputAt.value) !== null && _MessageInputAt$value !== void 0 && _MessageInputAt$value.style)) {
        return;
      }
      MessageInputAt.value.style.left = position.value.left + 'px';
      MessageInputAt.value.style.top = position.value.top - MessageInputAt.value.clientHeight + 'px';
    });
    var closeAt = () => {
      showAtList.value = false;
      showMemberList.value = allMemberList.value;
      position.value = {
        left: 0,
        top: 0
      };
    };
    var selectItem = index => {
      if (isPC && TUIGlobal.selectItem) {
        TUIGlobal.selectItem(index);
      } else {
        var _showMemberList$value;
        if (showMemberList !== null && showMemberList !== void 0 && (_showMemberList$value = showMemberList.value) !== null && _showMemberList$value !== void 0 && _showMemberList$value.length) {
          var item = showMemberList === null || showMemberList === void 0 ? void 0 : showMemberList.value[index];
          emits('insertAt', {
            id: item === null || item === void 0 ? void 0 : item.userID,
            label: (item === null || item === void 0 ? void 0 : item.nick) || (item === null || item === void 0 ? void 0 : item.userID)
          });
        }
      }
      closeAt();
    };
    var handleMemberAvatar = item => {
      return (item === null || item === void 0 ? void 0 : item.avatar) || 'https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png';
    };
    var handleMemberName = item => {
      return item !== null && item !== void 0 && item.nick ? item === null || item === void 0 ? void 0 : item.nick : item === null || item === void 0 ? void 0 : item.userID;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(BottomPopup, {
        show: _unref(showAtList),
        onOnClose: closeAt
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          ref_key: "MessageInputAt",
          ref: MessageInputAt,
          class: _normalizeClass([_unref(isPC) ? 'message-input-at' : 'message-input-at-h5'])
        }, [_createElementVNode("div", _hoisted_1, [!_unref(isPC) ? (_openBlock(), _createElementBlock("header", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_unref(TUITranslateService).t("TUIChat.选择提醒的人")), 1)])) : _createCommentVNode("", true), _createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showMemberList), (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            key: index,
            ref_for: true,
            ref_key: "memberListItems",
            ref: memberListItems,
            class: _normalizeClass(["member-list-box-body", [index === _unref(selectedIndex) && 'selected']]),
            onClick: $event => selectItem(index)
          }, [_createElementVNode("img", {
            class: "member-list-box-body-avatar",
            src: handleMemberAvatar(item)
          }, null, 8, _hoisted_6), _createElementVNode("span", _hoisted_7, _toDisplayString(handleMemberName(item)), 1)], 10, _hoisted_5);
        }), 128))])], 512)], 2)]),
        _: 1
      }, 8, ["show"]);
    };
  }
});